import React, { Component } from 'react';
import styled from 'styled-components';

import { Button } from './Button';
import { Input } from './Input';

const FilterWrapper = styled.div`
  width: 100%;
  padding: 5px;
  & input {
    margin-bottom: 5px;
  }
`;

export class MinMaxFilter extends Component {
  constructor(props) {
    super(props);
    this.handleMinChange = this.handleMinChange.bind(this);
    this.handleMaxChange = this.handleMaxChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      min: '',
      max: '',
    };
  }

  handleMinChange(e) {
    this.setState({min: e.target.value});
  }
  handleMaxChange(e) {
    this.setState({max: e.target.value});
  }
  handleSubmit() {
    this.props.onSubmit(this.state, this.props.label);
  }

  render() {
    const {min, max} = this.state;
    const {label} = this.props;
    const isDate = label === 'date' || label === 'application_date';

    return (
      <FilterWrapper>
        <Input
          onChange={this.handleMinChange}
          placeholder={`${label} min`.replace(/_/g, ' ')}
          type={isDate ? 'date' : 'text'}
          value={min}
        />
        <Input
          onChange={this.handleMaxChange}
          placeholder={`${label} max`.replace(/_/g, ' ')}
          type={isDate ? 'date' : 'text'}
          value={max}
        />
        <Button
          block
          onClick={this.handleSubmit}
        >
          FILTER
        </Button>
      </FilterWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/MinMaxFilter.js